<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.entrada"
            :disabled-button-search="true"
            ref="DataTable"
            sort-by="dataDocumento"
        >
            <template v-slot:cell(valor)="{ value }">
                {{ getValorFormatted(value) }}
            </template>

            <template v-slot:cell(finalizada)="{ value }">
                {{ value ? 'SIM' : 'NÃO' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="handleEdit(item)"
                    authorize="update-almoxarifado-entrada"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.finalizada"
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    authorize="destroy-almoxarifado-entrada"
                    :title="item.finalizada ? 'Não é permitido excluir entrada finalizada' : 'Excluir'"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>
    </div>
</template>

<script>
// Mixins.
import { repository, error, formats } from '@/mixins'

import moment from 'moment'
import { mapActions } from 'vuex'

export default {
    created() {

        this.repositories = {
            entrada: this.getConectaSusRepository('almoxarifado.entrada'),
            balancete: this.getConectaSusRepository('almoxarifado.balancete'),
        }
    },
    computed: {
        fields() {

            return [
                {
                    name: 'almoxarifadoEntradaDocumento.data',
                    key: 'dataDocumento',
                    label: 'Data do documento',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroFornecedor.nomeFantasia',
                    key: 'fornecedorNomeFantasia',
                    label: 'Fornecedor',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroOrigemProgramatica.nome',
                    key: 'origemProgramaticaNome',
                    label: 'Origem programática',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoEntradaDocumento.numero',
                    key: 'numero',
                    label: 'Número',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoEntradaDocumento.numeroPedido',
                    key: 'numeroPedido',
                    label: 'Código do pedido',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'valor',
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                },
                {
                    name: 'almoxarifadoDocumentoTipo.nome',
                    key: 'tipoNome',
                    label: 'Tipo',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoEntrada.createdAt',
                    key: 'dataEntrada',
                    label: 'Data da entrada',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'finalizada',
                    label: 'Finalizada',
                    class: 'col-min',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getValorFormatted(valor) {

            return this.formatMoney(Number.parseFloat(valor), 6)
        },
        handleEdit(item) {

            const data = moment(item.dataDocumento, 'DD/MM/YYYY').format('YYYY-MM-DD')

            this.setLoading()

            this.repositories.balancete.checkDate(data)
                .then(({ data }) => {

                    if (!data.mesFechado) {

                        this.$router.push({ name: 'almoxarifado-entrada-edit', params: { id: item.id } })

                        return
                    }

                    this.showValidationNotification(
                        'A data do documento corresponde a um mês já finalizado. Alteração não permitida.'
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.entrada.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a entrada?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error, formats ],
}
</script>